"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// utils

/* ++++++++++ --------------- Edit Info CTA: DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'EditInfoCTA',
  group: _definitionhelpers.groupNames.ctas,
  props: {
    editable: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    savingData: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    formName: {
      type: 'string',
      default: 'formNameHere'
    },
    saveFormData: {
      type: 'function',
      default: function _default() {
        return console.log('save form data');
      }
    },
    setFormEditableState: {
      type: 'function',
      default: function _default(formName, save) {
        console.log('set form editable state');
        console.log(formName);
        console.log(save);
      }
    },
    discardChanges: {
      type: 'function',
      default: function _default(formName) {
        console.log('discard changes');
        console.log(formName);
      }
    }
  }
};
exports.default = _default2;